export default __webpack_public_path__ + "static/media/ORYX_KnowledgeBaseIcon.20d3000b.svg";